export interface ERROR {
  title: string;
  message: string;
}

export interface DIALOG {
  title: string;
  message: string;
}

interface ApplicationState {
  error: ERROR;
  dialog: DIALOG;
  preventRouteChange: Boolean;
}

const initialState = {
  error: { title: "", message: "" },
  dialog: { title: "", message: "" },
  preventRouteChange: false,
};

const getters = {
  getError: (state: ApplicationState) => state.error,
  getDialog: (state: ApplicationState) => state.dialog,
  getPreventRouteChange: (state: ApplicationState) => state.preventRouteChange,
};

const actions = {
  setError(context: any, error: ERROR) {
    context.commit("SET_ERROR", error);
  },
  clearError(context: any) {
    context.commit("CLEAR_ERROR");
  },
  setDialog(context: any, dialog: DIALOG) {
    context.commit("SET_DIALOG", dialog);
  },
  clearDialog(context: any) {
    context.commit("CLEAR_DIALOG");
  },
  setPreventRouteChange(context: any, value: Boolean) {
    context.commit("SET_PREVENT_ROUTE_CHANGE", value);
  },
};

const mutations = {
  SET_ERROR(state: ApplicationState, error: ERROR) {
    state.error = error;
  },
  CLEAR_ERROR(state: ApplicationState) {
    state.error = { title: "", message: "" };
  },
  SET_DIALOG(state: ApplicationState, dialog: DIALOG) {
    state.dialog = dialog;
  },
  CLEAR_DIALOG(state: ApplicationState) {
    state.dialog = { title: "", message: "" };
  },
  SET_PREVENT_ROUTE_CHANGE(state: ApplicationState, value: Boolean) {
    state.preventRouteChange = value;
  },
};

export const application = {
  namespaced: true,
  initialState,
  getters,
  actions,
  mutations,
};
